// API configuration
// Use empty string to use relative paths which will be proxied by Vite dev server
export const API_URL = import.meta.env.VITE_API_URL || '';

export const API_ENDPOINTS = {
  auth: `${API_URL}/api/auth`,
  tenants: `${API_URL}/api/tenants`,
  users: `${API_URL}/api/users`,
  groups: `${API_URL}/api/groups`,
  templates: `${API_URL}/api/templates`,
  assignments: `${API_URL}/api/assignments`,
  deployments: `${API_URL}/api/deployments`,
  oauth: `${API_URL}/oauth`,
};
